import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import EuReadinessPharmaEs from "@/pages/EuReadinessPharmaEs";

export const Route = createFileRoute("/es/eu-readiness-pharma")({
  head: () => buildRouteHead("/es/eu-readiness-pharma"),
  component: EuReadinessPharmaEs,
});

